module.exports = __webpack_public_path__ + "static/img/wqx.971cfd7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/error/wqx.jpg
// module id = b5lU
// module chunks = 1